import type {
    RequiredTranslatable} from "@@/shared/translations/translation";
import {
    translation,
} from "@@/shared/translations/translation";
import { z } from "zod";

const accommodationResourceImageReferenceTags = [
    "general",
    "bedroom",
    "bathroom",
    "kitchen",
    "living-room",
    "dining-room",
    "balcony",
    "terrace",
    "garden",
    "pool",
    "view",
] as const;

type AccommodationResourceImageReferenceTag =
    (typeof accommodationResourceImageReferenceTags)[number];
const accommodationResourceImageReferenceTagZodEnum = z.enum(
    accommodationResourceImageReferenceTags,
);

type AccommodationResourceImageReferenceTagMeta = {
    [Tag in AccommodationResourceImageReferenceTag]: {
        tag: Tag;
        title: RequiredTranslatable;
    };
};

const accommodationResourceImageReferenceTagMeta: AccommodationResourceImageReferenceTagMeta =
    {
        general: {
            tag: "general",
            title: translation({
                sv: "Generell",
                en: "General",
            }),
        },
        bedroom: {
            tag: "bedroom",
            title: translation({
                sv: "Sovrum",
                en: "Bedroom",
            }),
        },
        bathroom: {
            tag: "bathroom",
            title: translation({
                sv: "Badrum",
                en: "Bathroom",
            }),
        },
        kitchen: {
            tag: "kitchen",
            title: translation({
                sv: "Kök",
                en: "Kitchen",
            }),
        },
        "living-room": {
            tag: "living-room",
            title: translation({
                sv: "Vardagsrum",
                en: "Living room",
            }),
        },
        "dining-room": {
            tag: "dining-room",
            title: translation({
                sv: "Matsal",
                en: "Dining room",
            }),
        },
        balcony: {
            tag: "balcony",
            title: translation({
                sv: "Balkong",
                en: "Balcony",
            }),
        },
        terrace: {
            tag: "terrace",
            title: translation({
                sv: "Terrass",
                en: "Terrace",
            }),
        },
        garden: {
            tag: "garden",
            title: translation({
                sv: "Trädgård",
                en: "Garden",
            }),
        },
        pool: {
            tag: "pool",
            title: translation({
                sv: "Pool",
                en: "Pool",
            }),
        },
        view: {
            tag: "view",
            title: translation({
                sv: "Utsikt",
                en: "View",
            }),
        },
    };

export {
    accommodationResourceImageReferenceTagMeta,
    accommodationResourceImageReferenceTagZodEnum,
    accommodationResourceImageReferenceTags,
};
export type {
    AccommodationResourceImageReferenceTag,
    AccommodationResourceImageReferenceTagMeta,
};
